/*
 *
 * Modal actions
 *
 */

import * as constants from './constants';

export function showModal(name) {
  return {
    type: constants.SHOW_MODAL,
    name,
  };
}

export function hideModal(name) {
  return {
    type: constants.HIDE_MODAL,
    name,
  };
}
